import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {navigator} from 'lit-element-router';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import store from '../store';
import {setMedia} from '../slices/statusSlice';


@customElement('summary-panel')
export class SummaryPanel extends connect(store)(navigator(LitElement)) {

	static styles = css`
	  :host {
		display: flex;
		flex-direction: column;
		gap: var(--large-padding);
		height: 100%;
		overflow-y: scroll;
		margin-top: -101px;
	  }
	  :host::-webkit-scrollbar {
		display: none;
	  }

	`;

	@property({type: Boolean})
	active = false;


	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(s) {
		this.state = s;
		this.status = s.status;
		this.lang = s.status.lang;
		this.active = s.status.summaryActive;
	}

	connectedCallback() {
		super.connectedCallback();
		addEventListener('keydown', this.handleKeydown);
	}

	handleKeydown = (e) => {
		switch (e.keyCode) {
			case 27: // ESC
				if (this.active) {
					this.closeSummary();
				}
				break;
		}
	};

	closeSummary(e) {
		store.dispatch(setMedia({media: 'sections'}));
	}

	render() {
		return html`
			<visual-lightprofile-summary></visual-lightprofile-summary>
		`;
	}
}
